import { Pause, Play } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import { Button } from './ui/button';

export const MusicPlayer = ({ className = '' }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [volume, setVolume] = useState(70);
  const trackName = 'Anima Christi';
  const audioRef = useRef(null);
  const trackSrc = '/anima_christi.mp3';

  const updateVolume = (nextVolume) => {
    const clampedVolume = Math.min(100, Math.max(0, nextVolume));
    setVolume(clampedVolume);

    if (audioRef.current) {
      audioRef.current.volume = clampedVolume / 100;
      audioRef.current.muted = clampedVolume === 0;
    }
  };

  const togglePlayback = () => {
    setIsPlaying((current) => !current);
  };

  useEffect(() => {
    if (!audioRef.current) {
      return;
    }
    audioRef.current.volume = volume / 100;
    audioRef.current.muted = volume === 0;
  }, [volume]);

  useEffect(() => {
    if (!audioRef.current) {
      return;
    }

    if (isPlaying) {
      audioRef.current.volume = volume / 100;
      audioRef.current.muted = volume === 0;
      audioRef.current.play().catch((error) => {
        console.error('Erro ao tocar áudio:', error);
        setIsPlaying(false);
      });
    } else {
      audioRef.current.pause();
    }
  }, [isPlaying, volume]);

  return (
    <div className={`music-player ${className}`} data-testid="music-player">
      <div className="flex flex-col sm:flex-row sm:flex-wrap items-start sm:items-center gap-4">
        <p className="text-[color:var(--text-primary)] text-sm font-medium tracking-wide">
          {trackName}
        </p>
        <audio
          ref={audioRef}
          src={trackSrc}
          onEnded={() => setIsPlaying(false)}
          onLoadedMetadata={() => updateVolume(volume)}
          preload="metadata"
        />
        <div className="flex items-center gap-3 w-full">
          <Button
            type="button"
            variant="outline"
            size="icon"
            onClick={togglePlayback}
            className="border-[#D4AF37]/40 text-[color:var(--gold)] hover:bg-[#D4AF37]/10"
            aria-label={isPlaying ? 'Pausar' : 'Tocar'}
          >
            {isPlaying ? <Pause className="w-4 h-4" /> : <Play className="w-4 h-4" />}
          </Button>
          <div className="music-player-volume">
            <span className="text-[color:var(--text-secondary)] text-xs uppercase tracking-[0.2em]">Volume</span>
            <input
              type="range"
              min="0"
              max="100"
              value={volume}
              onChange={(event) => updateVolume(Number(event.target.value))}
              className="music-player-slider"
              aria-label="Volume"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
